/* RIFT // VOLT — product gallery, variant picker, quantity steppers, cart page */
(() => {
  const d = document;
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(pointer: fine)').matches;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => [...c.querySelectorAll(s)];
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const money = (c) => (window.RX && window.RX.money ? window.RX.money(c) : (c / 100).toFixed(2));

  /* ---------- quantity steppers ---------- */
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]');
    if (!b) return;
    const input = $('input', b.closest('.rx-qty'));
    const min = Number(input.min || 1);
    input.value = Math.max(min, (Number(input.value) || min) + Number(b.dataset.step));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- gallery ---------- */
  function initGallery(g) {
    const track = $('.rx-gallery__slides', g), slides = $$('.rx-gallery__slide', g), thumbs = $$('.rx-thumb', g), count = $('[data-gallery-count]', g);
    if (!track || !slides.length) return;
    let idx = 0;
    const pad = (n) => String(n).padStart(2, '0');
    const mark = () => {
      thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === idx); t.setAttribute('aria-current', i === idx); });
      if (count) count.textContent = `${pad(idx + 1)} / ${pad(slides.length)}`;
    };
    const go = (i, smooth = true) => {
      idx = clamp(i, 0, slides.length - 1);
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: smooth && !RM ? 'smooth' : 'auto' });
      mark();
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    $$('[data-gallery-prev]', g).forEach((b) => b.addEventListener('click', () => go(idx - 1 < 0 ? slides.length - 1 : idx - 1)));
    $$('[data-gallery-next]', g).forEach((b) => b.addEventListener('click', () => go(idx + 1 >= slides.length ? 0 : idx + 1)));
    let st = 0;
    track.addEventListener('scroll', () => {
      clearTimeout(st);
      st = setTimeout(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) { idx = i; mark(); } }, 60);
    }, { passive: true });
    if (FINE) slides.forEach((s) => {
      s.addEventListener('click', () => s.classList.toggle('is-zoom'));
      s.addEventListener('pointermove', (e) => {
        const r = s.getBoundingClientRect();
        s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      s.addEventListener('pointerleave', () => s.classList.remove('is-zoom'));
    });
    g.goToMedia = (id) => { const i = slides.findIndex((s) => s.dataset.mediaId === String(id)); if (i > -1) go(i); };
    mark();
  }
  $$('[data-gallery]').forEach(initGallery);
  d.addEventListener('shopify:section:load', (e) => $$('[data-gallery]', e.target).forEach(initGallery));

  /* ---------- variant picker ---------- */
  const pj = $('#rx-product-json');
  if (pj) {
    const product = JSON.parse(pj.textContent);
    const form = $('[data-product-form]');
    const idInput = form && $('input[name="id"]', form);
    const sets = $$('[data-option-index]');
    const priceEl = $('[data-price]'), cmpEl = $('[data-compare]'), saveEl = $('[data-save]');
    const atcs = $$('[data-atc]'), gallery = $('[data-gallery]');
    const label = (v) => (!v ? 'Unavailable' : v.available ? (atcs[0] && atcs[0].dataset.label) || 'Add to cart' : 'Sold out');
    const selected = () => sets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const update = (initial) => {
      const opts = selected();
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      sets.forEach((fs, si) => {
        const legendVal = $('[data-option-value]', fs);
        if (legendVal) legendVal.textContent = opts[si] || '';
        $$('input', fs).forEach((inp) => {
          const ok = product.variants.some((x) => x.available && x.options[si] === inp.value && x.options.every((o, k) => k === si || o === opts[k]));
          const lab = inp.nextElementSibling;
          if (lab) lab.classList.toggle('is-unavail', !ok);
        });
      });
      atcs.forEach((b) => { b.disabled = !v || !v.available; const l = $('.rx-btn__label', b); if (l) l.textContent = label(v); });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmpEl) { cmpEl.textContent = sale ? money(v.compare_at_price) : ''; cmpEl.hidden = !sale; }
      if (saveEl) { saveEl.hidden = !sale; if (sale) saveEl.textContent = `Save ${Math.round((1 - v.price / v.compare_at_price) * 100)}%`; }
      $$('[data-sticky-price]').forEach((el) => { el.textContent = money(v.price); });
      if (!initial && v.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(v.featured_media.id);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
    };
    sets.forEach((fs) => fs.addEventListener('change', () => update(false)));
    if (sets.length) update(true);

    const sticky = $('.rx-sticky-atc'), main = form && $('[data-atc]', form);
    if (sticky && main) {
      new IntersectionObserver(([e]) => { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(main);
      $('[data-atc]', sticky).addEventListener('click', () => (form.requestSubmit ? form.requestSubmit() : form.submit()));
    }
  }

  /* ---------- cart page: auto-update on quantity change ---------- */
  const cartForm = $('[data-cart-form]');
  if (cartForm) cartForm.addEventListener('change', (e) => { if (e.target.matches('input[type="number"]')) cartForm.submit(); });
})();